import React from 'react';
import ReactDOM from 'react-dom/client';

export class WidgetHelper {
    public static register<P extends object>(
        component:
            | React.FunctionComponent<P>
            | React.ComponentClass<P>
            | string,
        selectors: string
    ) {
        const hosts = document.querySelectorAll(selectors);
        for (let i = 0, c = hosts.length; i < c; i++) {
            const host = hosts[i] as HTMLElement;
            const domChildren: Element[] = [];

            for (let j = 0, jc = host.children.length; j < jc; j++) {
                domChildren.push(host.children[j]);
            }

            const data: any = { ...host.dataset, domChildren };

            const root = ReactDOM.createRoot(host);
            root.render(React.createElement(component, data));

            host.classList.add('widget-loaded');
        }
    }
}
